import { axios } from '@Root/API'

export const get = (entity, entityType) => {
	return axios.get(`table-manager/columns/entity/${entity}/entity-type/${entityType}`)
}
